import { render } from "./IconKakao.vue?vue&type=template&id=8c2462da"
import script from "./IconKakao.vue?vue&type=script&lang=js"
export * from "./IconKakao.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__